export default {
    noReg: /^[a-zA-Z]+((_|-)[a-zA-Z]+)*$/,
};
